import type { ErrorMap } from '@/app/error-registry';

export const NOTES_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'NoteContent.Required': 'notes:apiErrors.contentRequired',
    'NoteTitle.TooLong': 'notes:apiErrors.titleTooLong',
    'NoteContent.TooLong': 'notes:apiErrors.contentTooLong',
    default: 'notes:apiErrors.createDefault',
  },
};

export const NOTES_UPDATE_ERROR_MAP: ErrorMap = {
  PUT: {
    'NoteContent.Required': 'notes:apiErrors.contentRequired',
    'NoteTitle.TooLong': 'notes:apiErrors.titleTooLong',
    'NoteContent.TooLong': 'notes:apiErrors.contentTooLong',
    'Note.NotFound': 'notes:apiErrors.notFound',
    default: 'notes:apiErrors.updateDefault',
  },
};

export const NOTES_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    default: 'notes:apiErrors.deleteDefault',
  },
};

export const NOTES_HISTORY_ERROR_MAP: ErrorMap = {
  GET: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    default: 'notes:apiErrors.historyDefault',
  },
};

export const NOTES_VERSION_ERROR_MAP: ErrorMap = {
  GET: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    'Note.VersionNotFound': 'notes:apiErrors.versionNotFound',
    default: 'notes:apiErrors.historyDefault',
  },
};

export const NOTES_RESTORE_ERROR_MAP: ErrorMap = {
  POST: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    'Note.VersionNotFound': 'notes:apiErrors.versionNotFound',
    default: 'notes:apiErrors.restoreDefault',
  },
};

export const NOTES_EXPORT_ERROR_MAP: ErrorMap = {
  GET: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    default: 'notes:apiErrors.exportDefault',
  },
};

export const NOTES_CONVERT_TO_TASK_ERROR_MAP: ErrorMap = {
  POST: {
    'Note.NotFound': 'notes:apiErrors.notFound',
    'Board.NotFound': 'notes:apiErrors.boardNotFound',
    'Project.NotFound': 'notes:apiErrors.projectNotFound',
    'Member.NotFound': 'notes:apiErrors.memberNotFound',
    default: 'notes:apiErrors.convertToTaskDefault',
  },
};
